import { z } from 'zod';
import { Uuid, IsoDateTime, success } from '@secretaa/http-contract';
import { CapabilityRef, CapabilitySpec } from './capabilities.ts';
/** Planning metadata only. Never a release-verification, connection or execution proof. */
export const Request=z.object({workspaceId:Uuid,subjectId:Uuid,projectId:Uuid,capabilityRef:CapabilityRef}).strict();
export const Descriptor=z.object({spec:CapabilitySpec,revision:z.number().int().positive(),
 state:z.enum(['PLANNING_ENABLED','SUSPENDED','RETIRED']),
 executor:z.literal('INTERNAL_PRIMITIVE'),primitive:z.literal('PROJECT_QUERY'),
}).strict().refine(v=>v.spec.effect==='READ'&&v.spec.connectionProfileRef===null&&v.spec.requiredPermissionKeys.length===1&&v.spec.requiredPermissionKeys[0]==='project.read','PLANNING_PRIMITIVE_UNSUPPORTED');
export const Result=z.object({request:Request,descriptor:Descriptor.nullable(),checkedAt:IsoDateTime,expiresAt:IsoDateTime}).strict();
export const Response=success(Result);
export type Request=z.infer<typeof Request>;
export type Result=z.infer<typeof Result>;
export const PATH='/internal/v1/capability-planning';

import {ModelProfileRegistryVersion} from './model-registry.ts';
export const ProfileRequest=z.object({workspaceId:Uuid,subjectId:Uuid,projectId:Uuid,profileRef:CapabilityRef}).strict();
export const ProfileResult=z.object({request:ProfileRequest,profile:ModelProfileRegistryVersion.nullable(),checkedAt:IsoDateTime,expiresAt:IsoDateTime}).strict();
export const ProfileResponse=success(ProfileResult);
export type ProfileRequest=z.infer<typeof ProfileRequest>;
export type ProfileResult=z.infer<typeof ProfileResult>;
export const PROFILE_PATH='/internal/v1/processing-planning-profile';

/** Exact typed-contract discovery; never a free-text search over tenant records. */
export const SearchRequest=z.object({workspaceId:Uuid,subjectId:Uuid,projectId:Uuid,inputContractRef:CapabilityRef,outputContractRef:CapabilityRef,dataPolicyRef:CapabilityRef,effect:CapabilitySpec.shape.effect}).strict();
export const SearchResult=z.object({request:SearchRequest,items:z.array(Descriptor).max(8),complete:z.boolean(),checkedAt:IsoDateTime,expiresAt:IsoDateTime}).strict();
export const SearchResponse=success(SearchResult);
export type SearchRequest=z.infer<typeof SearchRequest>;
export type SearchResult=z.infer<typeof SearchResult>;
export const SEARCH_PATH='/internal/v1/capability-planning/search';
